import styled from 'styled-components';

export const Container = styled.div`
background-color: #fff;
border-radius: 10px;
box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
position: relative;
overflow: hidden;
width: 678px;
max-width: 90%;
min-height: 650px;
margin: auto;
margin-top: 6.5%;

@media (max-width: 600px) {
    margin-top: 20%;
}

`;

export const SignUpContainer = styled.div`
 position: absolute;
 top: 0;
 height: 100%;
 transition: all 0.6s ease-in-out;
 left: 0;
 width: 50%;
 opacity: 0;
 ${props => props.signinIn !== true ? `
   transform: translateX(100%);
   opacity: 1;
   z-index: 1;
 `
    : null}
`;


export const SignInContainer = styled.div`
position: absolute;
top: 0;
height: 100%;
transition: all 0.6s ease-in-out;
left: 0;
width: 50%;
${props => (props.signinIn !== true ? `transform: translateX(100%);` : null)}
`;

export const Form = styled.form`
background-color: #ffffff;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 0 50px;
height: 100%;
text-align: center;
`;

export const NewBusinessForm = styled.form`
margin-top: 20px;
background-color: #ffffff;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 0 50px;
height: 100%;
text-align: center;
`;

export const NewBusinessContainer = styled.div`
background-color: #fff;
border-radius: 10px;
box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
position: relative;
overflow: hidden;
width: 550px;
max-width: 80%;
min-height: 650px;
margin: auto;
margin-top: 6.5%;
margin-bottom: 20px;
padding-bottom: 20px;

@media (max-width: 600px) {
    margin-top: 20%;
}

`;

export const QuickAppointContainer = styled.div`
background-color: #fff;
border-radius: 10px;
box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
position: relative;
overflow: hidden;
width: 550px;
max-width: 80%;
margin: auto;
margin-top: 8%;
margin-bottom: 20px;
padding-bottom: 20px;

@media (max-width: 600px) {
    margin-top: 20%;
}

`;

export const AvailableContainer = styled.div`
width: 250px;
margin: auto;
`;
export const Title = styled.h1`
font-weight: bold;
margin: 0;

@media (max-width: 600px) {
    font-size: 1.5rem;
}

`;

export const Input = styled.input`
background-color: #eee;
border: none;
border-radius: 10px;
padding: 12px 15px;
margin: 8px 0;
width: 280px;

@media (max-width: 650px) {
    width: 35vw;
}
`;

export const AppointmentInput = styled.input`
background-color: #eee;
border: none;
border-radius: 10px;
padding: 12px 15px;
margin: 8px 0;
width: 100%;
`;

export const NewBusinessInput = styled.input`
background-color: #eee;
border: none;
border-radius: 10px;
padding: 12px 15px;
margin: 8px 0;
width: 255px;
`;

export const Select = styled.select`
background-color: #eee;
border-radius: 10px;
width: 550px;
max-width: 50%;
padding: 12px 15px;
margin: 8px 0;
`;

export const SelectOfTime = styled.select`
background-color: #eee;
border: none;
padding: 12px 15px;
width: 100%;
`;

export const TextArea = styled.textarea`
background-color: #eee;
border: none;
border-radius: 10px;
padding: 12px 15px;
margin: 8px 0;
width: 255px;
height: 150px;
`;

export const AppointmentTextArea = styled.textarea`
background-color: #eee;
border: none;
border-radius: 10px;
padding: 12px 15px;
margin: 8px 0;
width: 100%;
height: 130px;
`;


export const Button = styled.button`
   border-radius: 20px;
   border: 1px solid #ff4b2b;
   background-color: #ff4b2b;
   color: #ffffff;
   font-size: 12px;
   font-weight: bold;
   padding: 12px 45px;
   letter-spacing: 1px;
   text-transform: uppercase;
   transition: transform 80ms ease-in;
   &:active{
       transform: scale(0.95);
   }
   &:focus {
       outline: none;
   }
`;

export const ButtonPic = styled.div`
   border-radius: 25px;
   margin-top: 15px;
   margin-bottom: 20px;
   background-color: #ff2b2b;
   border: white;
   height: 50px;
   color: #ffffff;
   font-size: 12px;
   font-weight: bold;
   letter-spacing: 1px;
   text-transform: uppercase;
   transition: transform 80ms ease-in;
   &:active{
       transform: scale(0.95);
   }
   &:focus {
       outline: none;
   }

   @media (max-width: 600px) {
    font-size: 0.6rem;
    }
`;

export const Pic = styled.div`
position: relative;
width: 200px;
height: 200px;
margin-top: 50px;
margin: auto;
`

export const GhostButton = styled(Button)`
background-color: transparent;
border-color: #ffffff;
`;

export const Anchor = styled.a`
color: #333;
font-size: 14px;
text-decoration: none;
margin: 15px 0;
`;
export const OverlayContainer = styled.div`
position: absolute;
top: 0;
left: 50%;
width: 50%;
height: 100%;
overflow: hidden;
transition: transform 0.6s ease-in-out;
${props =>
    props.signinIn !== true ? `transform: translateX(-100%);` : null}
`;

export const Overlay = styled.div`
background: #ff416c;
background: -webkit-linear-gradient(to right, #ff4b2b, #ff416c);
background: linear-gradient(to right, #ff4b2b, #ff416c);
background-repeat: no-repeat;
background-size: cover;
background-position: 0 0;
color: #ffffff;
position: relative;
left: -100%;
height: 100%;
width: 200%;
transform: translateX(0);
transition: transform 0.6s ease-in-out;
${props => (props.signinIn !== true ? `transform: translateX(50%);` : null)}
`;

export const OverlayPanel = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0 40px;
    text-align: center;
    top: 0;
    height: 100%;
    width: 50%;
    transform: translateX(0);
    transition: transform 0.6s ease-in-out;
`;

export const LeftOverlayPanel = styled(OverlayPanel)`
  transform: translateX(-20%);
  ${props => props.signinIn !== true ? `transform: translateX(0);` : null}
`;

export const RightOverlayPanel = styled(OverlayPanel)`
    right: 0;
    transform: translateX(0);
    ${props => props.signinIn !== true ? `transform: translateX(20%);` : null}
`;

export const Paragraph = styled.p`
font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px
`;